/**
 * @license @tabler/icons-vue v3.28.1 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createVueComponent from '../createVueComponent.mjs';

var IconEggFilled = createVueComponent("filled", "egg-filled", "IconEggFilled", [["path", { "d": "M12.002 2c-4.173 -.008 -8.002 6.058 -8.002 12.083c0 4.708 3.25 7.917 8 7.917c4.727 -.206 8 -3.328 8 -7.917c0 -6.02 -3.825 -12.075 -7.998 -12.083z", "key": "svg-0" }]]);

export { IconEggFilled as default };
//# sourceMappingURL=IconEggFilled.mjs.map
